import React, { useContext } from 'react';
import {
    View,
    colors,
    Text,
    GridColumn,
    Heading,
    Button,
} from '@fairygodboss/ui';
import window from 'global/window';
import { PageContext } from '../../../../../../contexts/ContextCreator';
import { VipWingSVG } from './VipWingSVG';
import ResponsivePicture from '../../../../../Elements/ResponsivePicture/ResponsivePicture';
import { DividerSVG } from '../../ContentBody/ConvincerSVGs';

export const UserProfile = () => {
    const { getUser, getUserGTMMetricsMetadata } = useContext(PageContext);
    const { username, logo, credential } = getUser();
    const { is_vip: isVip } = getUserGTMMetricsMetadata();

    const breakpoints = {
        mobile: {
            width: 256,
            transforms: {
                quality: 'auto',
                crop: 'scale',
                format: 'auto',
            },
        },
    };

    return (
        <View display={{ _: 'none', md: 'inherit' }}>
            <GridColumn
                size={{
                    xs: 0,
                    sm: 0,
                    md: window.innerWidth > 1054 ? 3 : 4,
                    lg: 3.05,
                }}
                pr={{ _: '0px', md: '24px', lg: '0px' }}
                pt="78px"
                css={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: '6px',
                    position: 'absolute',
                    right: '0px',
                    color: colors.neutral[100],
                    button: {
                        paddingLeft: '20px',
                        paddingRight: '20px',
                        backgroundColor: 'transparent',
                        borderColor: colors.secondary[70],
                        ':hover': {
                            backgroundColor: colors.secondary[10],
                        },
                        span: {
                            letterSpacing: '-0.4px',
                            color: colors.secondary[70],
                        },
                    },
                }}
            >
                <DividerSVG width="100" />

                <View position="relative">
                    <View
                        mt="22px"
                        height="128px"
                        width="128px"
                        borderRadius="50%"
                        overflow="hidden"
                        css={{
                            img: {
                                width: '128px !important',
                                height: '128px !important',
                            },
                        }}
                    >
                        <ResponsivePicture
                            cloudinaryID={
                                logo || '/v1/avatar_black_160_vtg7lw.svg'
                            }
                            alt={username}
                            breakpoints={breakpoints}
                            lazyLoad
                        />
                    </View>
                    {isVip ? (
                        <View position="absolute" bottom="-5px" right="0px">
                            <VipWingSVG />
                        </View>
                    ) : null}
                </View>

                <Heading
                    textAlign="center"
                    pt="24px"
                    fontWeight="700"
                    variant="headingXs"
                    as="h3"
                >
                    {username}
                </Heading>
                <Text
                    pt="8px"
                    fontSize="16px"
                    lineHeight="20px"
                    fontWeight="400px"
                    letterSpacing="-0.4px"
                    textAlign="center"
                >
                    {credential}
                </Text>
                <Button
                    mt="8px"
                    variant="secondary"
                    size="medium"
                    onPress={() => {
                        window.location.pathname = 'users/profile';
                    }}
                >
                    View my profile
                </Button>
            </GridColumn>
        </View>
    );
};
